import React, { useEffect, useState } from 'react';
import { Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import CTATable from './CTATable';

const CTAList = () => {
    const history = useHistory();
    let { url } = useRouteMatch();

    const [{ data, loading }, refetch] = useAxios({
        url: 'call-to-action',
        params: { admin: true }
    });
    const [{ id, loading: submitting }, submitForm] = useAxios(
        { url: `call-to-action` },
        { manual: true },
    );

    if (loading)
        return <Spinner className="absolute-center" label="Loading CTAs..." />;

    const clone = async (id) =>{
        let result = await submitForm({
            url: 'call-to-action/clone-cta?Id=' + id,
            method: 'POST',
        });
        if (!result.isAxiosError) {
            window.location.href = '/cobrand-settings-feature/call-to-action/' + result.data;
        }
    }

    return (
        <>
            <CTATable
                items={data.items}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => {
                    history.push(`${url}/${id}`)}}
                cloneOnClick={(id) => clone(id)}
                refetch={refetch}
                loading={loading}
            />
           
        </>
    );
}
export default CTAList;
